import { initFragmentOnClient } from 'lib/ssr-client-react'
import fragment from './index'
import { createLogger } from 'common/log'

const logger = createLogger('fragments/buyListFragment/client')

const fragmentName = 'buyListFragment'

const currentScript = document.currentScript

let previousSibling = currentScript.previousElementSibling
while (previousSibling) {
  if (previousSibling.id) break
  previousSibling = previousSibling.previousElementSibling
}

// DO NOT CHANGE UNLESS YOU REALLY KNOW WHAT YOU ARE DOING
initFragmentOnClient(fragment.Component, fragmentName, previousSibling.id)
if (module.hot) {
  module.hot.accept('./index', () => {
    logger.debug(`hot reloading ${fragmentName}`)
    const reload = require('./index').default
    initFragmentOnClient(reload.Component, fragmentName)
  })
}
